<template>
    <div>
        <div id="pop" class="pop" @touchmove.prevent :class="{show:h_visible}">
            <!-- 遮罩层 -->
            <div class="pop-mask" @click="clickCloseDialog()"></div>

            <!-- 内容区 -->
            <div
                id="pop_contain"
                class="pop-contain" ref="refpop">

                <!-- 运营区域 -->
                <div
                    v-if="operate_info.type=='image'&&show_operate"
                    :class="{opacity0:show_operate_opacity}"
                    class="operate-img"
                    id="operate_img">
                    <img :src="operate_info.banner_image" alt="png" @load="imageLoad">
                </div>
                <div
                    v-if="operate_info.type=='image_text'&&show_operate"
                    :class="{opacity0:show_operate_opacity}"
                    class="operate-position">
                    <div class="text-box">
                        <div class="main-title">{{ operate_info.banner_title }}</div>
                        <div class="sub-title">{{ operate_info.banner_sub_title }}</div>
                    </div>
                    <div class="img-box">
                        <img :src="operate_info.banner_image_right" alt="png" @load="imageLoad">
                    </div>
                </div>

                <!-- kkb半屏标题 -->
                <div class="hd flex_layout flex_xy_center">
                    <span class="fam">{{ title }}</span>
                    <div  @click="clickCloseDialog()" class="ico_close"><i></i></div>
                </div>

                <!-- 多充多送 -->
                <div v-if="accumact.accum_level_list && accumact.accum_level_list.length>0" class="buy_more_more_gifts">
                    <h3 class="title_warp">
                        <div class="title"><img v-if="accumact.accum_title_image" :src="accumact.accum_title_image"></div>
                        <p class="buy_record">已充值<span>{{(accumact.accum_recharge_value || 0)}}</span>元</p>
                        <!-- <p v-if="!!accumact.accum_desc" class="buy_record" @click.stop="clickBuyRecord">{{(accumact.accum_desc || '')}}</p>
                        <p v-else class="buy_record" @click.stop="clickBuyRecord">累计充值<span>{{(accumact.accum_recharge_value || 0)}}</span>元</p> -->
                        <div class="details_btn" @click.stop="clickBuyRecord">
                            <!-- <span class="d_text">获奖记录</span> -->
                            <span class="d_text">详情</span>
                            <span class="d_icon"></span>
                        </div>
                    </h3>
                    
                    <swiper :options="swiperOption1" class="view_swiper" ref="mySwiper1">
                        <swiper-slide style="swiper_item"  v-for="(item, index) in accumact.accum_level_list" :key="index">
                            <div class="buy_item">
                                <div 
                                    v-if="item.assign_status==5&&item.level_award_url || item.assign&&item.level_award_url"  
                                    class="see_btn"
                                    @click.stop="clickSeeRewardBtn(item)"
                                ></div>
                                <div v-if="item.assign_status == 2" class="label label_r">已领</div>
                                <div v-else class="label" style="padding:0">
                                    <img v-if="item.right_head_image" :src="item.right_head_image">
                                </div>
                                <div class="img-box" @click.stop="clickImageSeeReward(item)">
                                    <img v-if="item.image_new" :src="item.image_new"/>
                                </div>
                                <p>{{ item.level_award_text || "" }}</p>
                                <div 
                                    v-if="item.assign_status==1 || item.assign_status==3 || item.assign_status==6" 
                                    class="receive_btn"
                                    @click.stop="clickReceiveReward(item)"
                                >领取</div>
                                <div v-if="item.assign_status==1 || item.assign_status==3 || item.assign_status==6"  class="mask"></div>
                            </div>
                            <div 
                                :class="`progress_bar ${index==0?'first' : ''} ${index+1==accumact.accum_level_list.length?'last':''}`"
                            >
                                <p :class="`done ${item.radius ? 'radius' : ''}`" :style="`width:${item.w}%;`"></p>
                                <div :class="`tag ${item.w >= 50 ? 'bg' : ''}`">{{(item.level_value || 0)}}元</div>
                            </div>

                        </swiper-slide>
                    </swiper>
                </div>

                <!-- kkb余额 -->
                <div class="ft">
                    <div class="line1 flex_layout flex_x_spacebetween">
                        <div class="user-info-box flex_layout flex_y_center" @click="clickJumpLogin()">
                            <img :src="user_info.avatar_url || user_avatar" alt="png">
                            <div class="name">{{ is_login?user_info.nickname:"请登录"}}</div>
                        </div>
                        <span class="flex_layout flex_xy_center" @click="clickJumpRecharge()">余额：{{ is_login?mykkb:"--" }}</span>
                    </div>
                    <!-- <div v-show="mark" class="line2">提醒：{{ mark }}</div> -->
                </div>
                
                <!-- 充值档位 -->
                <div class="bd-box">
                    <div class="bd">
                        <swiper :options="swiperOption2" ref="mySwiper">
                            <swiper-slide v-for="(item, index) in list" :key="index" >
                                <div class="goods-box">
                                    <div 
                                        v-for="(item1,index1) in item"
                                        :key="index1"
                                        :class="index==chooseIndex&&index1==chooseIndex1?'choose-item':''"
                                        class="item re flex_layout flex_flexDirection_column flex_y_center"
                                        @click="setChooseIndex1(index1)">
                                        <div class="i0"><img :src="item1.show_image_url"></div>
                                        <div class="i1 ov flex_layout flex_xy_center">
                                            <img src="../img/icon.png" alt="png">
                                            <span class="fam">{{ item1.recharge_value || "" }}</span>
                                        </div>
                                        <!-- <div class="i2 ov fam" :class="{opacity0:!item1.words_info.explain_text}">
                                            <span>{{ item1.words_info.explain_text }}</span>
                                        </div> -->
                                        <div class="i2 ov fam">
                                            <span>¥{{ item1.real_price | filtersFenToYuan }}</span>
                                        </div>
                                        <div v-show="item1.recharge_good_type != 0" class="i3 ov fam">
                                            <span>限购一次</span>
                                        </div>
                                        <div class="i4 flex_layout flex_xy_center" :class="{opacity0:!item1.words_info.explain_text}">
                                            {{ item1.words_info.explain_text }}
                                        </div>
                                        <!-- <div class="i4 flex_layout flex_xy_center">
                                            ¥{{ item1.real_price | filtersFenToYuan }}
                                        </div> -->
                                        <!-- <div @click="clickJumpPay(item1)" class="i4 flex_layout flex_xy_center">
                                            <span class="fam">￥{{ item1.real_price | filtersFenToYuan }}</span>
                                        </div> -->
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                        <div class="button-box">
                            <div 
                                class="recharge-button"
                                @click="clickJumpPay">立即充值{{(list[chooseIndex]?list[chooseIndex][chooseIndex1].real_price:0) | filtersFenToYuan}}元</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 收银台组件 -->
            <cashdesk 
                ref="cashdesk"
                :visible.sync="visible_cashdesk"
                :param="param_cashdesk" 
                @payMessage="receiveCashdeskPayMessage"
                @errorMessage="receiveCashdeskErrorMessage"
            />
        </div>
        <!-- loading -->
        <Loading :visible="h_loading"/>
    </div>
</template>

<script>
//npm模块
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import cashdesk from '../../cashdesk/src/cashdesk'
//组件
import Loading from '../../common/Loading'
import slide from "../../../assets/animation/slide";

//公用方法 - 全局
import {
    toast,
    debug,
    ua,
    fenToYuan
} from '@kkmh/utils'

import {
    postAccumReceive // 多充多送点击领取奖励接口
} from "../../../assets/api";

//组件方法 - 局部
import { getPayParam, jumpToLogin } from "../../../assets/utils";
import {
    getBaseParam,
    getKkbViewData,
    getKkbList,
    jumpToRechargeCenter,
    jumpActivityDetails
} from "../js/common";
import {
    doTrackPopupShow,
    doTrackPopupItemImp,
    doTrackPopupItemClk,
    doTrack
} from "../js/track";
export default {
    components: {
      swiper,
      swiperSlide,
      Loading,
      cashdesk,
    },
    name: 'KkbHalfScreen',
    data () {
        let _this = this;
        return {
            h_loading           : false,
            h_visible           : false,
            swiperOption1       : {
                slidesPerView: 2.6, //5.1,
                on: {
                    init(swiper){
                        let accum_level_list = _this.accumact.accum_level_list;
                        if(accum_level_list && accum_level_list.length > 0){
                            accum_level_list.forEach((item, index)=>{
                                if(index <= 2){
                                    item.doTrack = true;
                                    doTrack('RechargeGiftImp', {
                                        SourceType: 'KK币充值半屏', 
                                        popupName: _this.title || '', 
                                        ActivityName: _this.accumact.activity_title,
                                        LiveActivityID: _this.accumact.activity_id,
                                        GearName: item.accum_level_id
                                    }); 
                                }
                            })
                        }
                    },
                    // slideChangeTransitionStart(){
                    //     console.log('slideChangeTransitionStart-0-0',this.activeIndex);
                    // },
                    slideChangeTransitionEnd(){
                        let accum_level_list = _this.accumact.accum_level_list;
                        let activeIndex = this.activeIndex+2;
                        if(accum_level_list && accum_level_list.length > 0){
                            accum_level_list.forEach((item, index)=>{
                                if(index <= activeIndex && !item.doTrack){
                                    item.doTrack = true;
                                    doTrack('RechargeGiftImp', {
                                        SourceType: 'KK币充值半屏', 
                                        popupName: _this.title || '', 
                                        ActivityName: _this.accumact.activity_title,
                                        LiveActivityID: _this.accumact.activity_id,
                                        GearName: item.accum_level_id
                                    }); 
                                }
                            })
                        }
                    }
                }
            },
            swiperOption2       : {
                // autoplay: true,//可选选项，自动滑动
                // slidesPerView: 'auto', //5.1,
                // slidesPerView: 3.3, //5.1,
                // loopedSlides: 4,
                pagination: {
                    el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                    clickable: true,            //轮播按钮支持点击
                },
                on: {
                    slideNextTransitionEnd:()=>{
                        // 埋点上报
                        this.slideNextPopupItemImp();
                    },
                    slidePrevTransitionStart:()=>{
                        // 埋点上报
                        this.setChooseIndex();
                    },
                    reachEnd:()=>{
                        // 埋点上报
                        this.endCheckPopupItemImp()
                    },
                }
                
            },
            //收银台参数
            visible_cashdesk    : false,
            param_cashdesk      : {},
            kkbdata             : {},
            j_curgood_info      : {},
            j_req               : {},
            slide_x:0,// 滑动出的slide尺寸
            track_popup_itemimp_count:0,// 记录itemimp上报次数
            accumact            : {},  // 多充多送

            list: [], // 每六个一分组
            user_info: {}, // 用户信息
            user_avatar: require("../img/user.png"),
            chooseIndex: 0,
            chooseIndex1: 0,
            operate_info: {}, // 运营位信息
            show_operate: true, // 是否展示运营位
            show_operate_opacity: true, // 运营位开始都为透明 防止闪一下
            is_login: false,
            is_drack: false, // 是否埋点
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param:{
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    watch:{
        visible:{
            handler(val){
                if(val) {
                    // 调用者先设置param然后设置visible，setTimeout可以解决此顺序正确赋值
                    setTimeout(() => {
                        this.h_loading = true;
                        this.init();
                        this.notifyResetVisibleFalse();
                    },0);
                }
            },
            deep:true
        },
        param:{
            handler(val){
                this.j_req = JSON.parse(JSON.stringify(val));
            },
            deep:true
        },
    },
    computed: {
        kkbgoods() {
            return this.kkbdata.goods || [];
        },
        title() {
            return this.kkbdata.title || '';
        },
        mykkb() {
            return this.kkbdata.mykkb || 0;
        },
        show_rechargecenter() {
            return this.kkbdata.show || false;
        },
        mark() {
            return this.kkbdata.mark || '';
        },
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    methods:{
        init(){
            (async () => {
                this.j_req = await getBaseParam(this.j_req);
                let issuccess = await this.getViewData();
                if (issuccess) {
                    this.openDialog();    
                }
            })();
        },
        // updateAccumact:是否只更新多充多送
        async getViewData(updateAccumact){
            let {code, data, message} = await getKkbViewData(this.j_req);
            if (code !== 200) {
                this.notifyErrorMessage(code, message, data);
                return false;
            }
            let {accumact, user, operate_info, is_login} = data;           
            this.user_info = user;
            this.operate_info = operate_info;
            this.is_login = is_login;
            // 计算进度条
            accumact = accumact || {};
            
            accumact.accum_desc = accumact.accum_desc || ''
            accumact.accum_desc = accumact.accum_desc.replace('#', '').replace('#', '') || '';
            accumact.accum_level_list = accumact.accum_level_list || [];
            let a_value = accumact.accum_recharge_value || 0; // 当前充值 13.8;//
            accumact.accum_level_list.forEach((item,index) => {
                let last_data = accumact.accum_level_list[index-1] || null; // 前一个数据
                let next_data = accumact.accum_level_list[index+1] || null; // 后一个数据
                let level_value = item.level_value || 0; // 当前充值档位的
                let last_data_value = last_data ? last_data.level_value : level_value; // 前一个充值档位
                let next_level_value = next_data ? next_data.level_value : level_value; // 后一个充值档位
                next_level_value = next_level_value || 0;
                // 计算右边 
                if (next_level_value - level_value > 0) {
                    item.r_value = (next_level_value - level_value) / 2
                } else {
                    item.r_value = next_level_value + 1;
                }
                // 计算左边
                if (level_value - last_data_value > 0) {
                    item.l_value = (level_value-last_data_value) / 2
                } else {
                    item.l_value = 0;
                }
                // 设置进度条
                if (a_value<=0) {
                    item.w = 0;
                    item.radius = true;
                    return;
                }
                if (a_value == level_value) {
                    item.w = 50;
                } else if (a_value > level_value) {
                    let val = a_value - level_value;
                    let v = val >= item.r_value
                    item.w = v ? 100 : 50 + Math.floor((val / (item.r_value / 0.5)) * 100);
                } else if (a_value<=level_value) {
                    let val = level_value - a_value;
                    let v = val >= item.l_value;
                    item.w = v ? 0 : Math.floor(100-((val/item.l_value) * 100))/2;
                } else {
                    item.w = 0;
                }

                // 进度条是否显示圆角
                if (item.w == 100) {
                    item.radius = a_value <= level_value+item.r_value;
                } else {
                    item.radius = true;
                }
            });
            if (updateAccumact) {
                this.accumact = accumact;
                this.kkbdata = data || {};
                return false;
            }
            this.oneToTwoDimension(data.goods)
            this.accumact = accumact;
            this.kkbdata = data || {};
            //初始化
            this.initSwiper();
            return true;
        },
        initSwiper() {
            this.$nextTick(() => {
                if (this.swiper.slides.length) {
                    this.swiper.update();
                    this.swiper.slideTo(0, 1000, false);
                    return null;    
                }
            });
        },

        // 多充多送: 点击累计充值-跳转奖励详情
        clickBuyRecord() {
            const url = this.accumact.award_url || '';
            doTrack('ClickRechargeGiftButton', {
                SourceType: 'KK币充值半屏', 
                popupName: this.title || '', 
                ButtonName: this.accumact.accum_desc || ''
            });
            jumpActivityDetails(url, (res, nativecallback_name) => {
                let {data={}} = res;
                if (data.curr_page_is_visible == 1) {
                    this.getViewData(true);
                    if (nativecallback_name) {
                        delete window[nativecallback_name] //释放内存    
                    }
                };
            });
        },

        // 多充多送: 点击放大镜,查看奖励详情
        clickSeeRewardBtn(item = null, type = false) {
            if (!item) {
                return false;
            }
            if (window.clickSeeRewardBtn) { // 防止重复点击
                return false;
            }
            if (!type) {
                doTrack('ClickRechargeGiftButton', {
                    SourceType: 'KK币充值半屏', 
                    popupName: this.title || '', 
                    ButtonName: '查看漫画按钮'
                });
            }
            window.clickSeeRewardBtn = true;
            const url = item.level_award_url || "";
            jumpActivityDetails(url, (res, nativecallback_name) => {
                let {data={}} = res;
                window.clickReceiveReward = false;
                window.clickSeeRewardBtn = false;
                if (data.curr_page_is_visible == 1) {
                    this.getViewData(true);
                    if (nativecallback_name) {
                        delete window[nativecallback_name] //释放内存    
                    }
                };
            });
        },

        // 点击多充多送档位封面图片
        clickImageSeeReward(item) {
            if (item.assign_status==5&&item.level_award_url || item.assign&&item.level_award_url) {
                this.clickSeeRewardBtn(item)
            } else {
                this.clickBuyRecord();
            }
        },

        // 多充多送: 点击领取奖励
        clickReceiveReward(item = null) {
            if (!item) {
                return false;
            }
            if (window.clickReceiveReward) { // 防止重复点击
                return false;
            }
            window.clickReceiveReward = true;
            doTrack('ClickRechargeGiftButton', {
                SourceType: 'KK币充值半屏', 
                popupName: this.title || '', 
                ButtonName: '领取'
            });
            // 仅作品奖励未领取
            if (item.level_award_url && item.assign_status==3) {
                this.clickSeeRewardBtn(item, true);
                return false;
            }
            // this.j_req增加xdevice信息，支持AB实验
            let senddata = {
                accum_level_id: item.accum_level_id, 
                activity_id: this.accumact.activity_id,
                ...this.j_req
            }
            postAccumReceive(senddata).then(res => {
                window.clickReceiveReward = false;
                let {code, data, message} = res;
                if (code !=200) {
                    toast(message);
                    return false;
                }
                data = data || {};
                data.toast = data.toast || "";
                if (data.toast) {
                    toast(data.toast);
                }
                if ((item.assign_status==1 || item.assign_status==6) && item.level_award_url) {
                    this.clickSeeRewardBtn(item, true);
                } else {
                    this.getViewData(true);
                }
            });

        },

        clickCloseDialog() {
            this.closeDialog();
        },

        // 跳转登录
        async clickJumpLogin() {
            if(!this.is_login) {
                let islogin = await jumpToLogin();
                if(islogin) {
                    this.init();
                }
            }
        },
        //跳转充值中心
        clickJumpRecharge() {
            jumpToRechargeCenter(this.j_req, (res, nativecallback_name) => {
                let {data={}} = res;
                if (data.curr_page_is_visible == 0) {
                    this.notifyRechargeCenterOpen();
                }
                if (data.curr_page_is_visible == 1) {
                    this.notifyRechargeCenterClose();
                    if (nativecallback_name) {
                        delete window[nativecallback_name] //释放内存    
                    }
                }
            })
        },
        setChooseIndex1(index) {
            this.chooseIndex1 = index;
            let item = this.list[this.chooseIndex][this.chooseIndex1];
            this.popupItemClk(item, "充值按钮");
        },
        // 支付商品
        clickJumpPay() {
            // doTrackClick('充值￥'+fenToYuan(item.real_price,2), this.j_req);
            let item = this.list[this.chooseIndex][this.chooseIndex1];
            this.popupItemClk(item, "充值BTN");
            this.j_curgood_info = item;
            this.param_cashdesk = getPayParam({
                ...this.j_req,                    
                good_id : item.id,  //必须-int 76
            });
            this.visible_cashdesk = true;
        },
        // 开启-半屏
        openDialog(){
            this.h_loading = false;
            this.h_visible = true;
            this.$nextTick(() => {
                slide.up(this.$refs.refpop, () => {
                    // 上报popupshow
                    this.popUpShow();
                    // 上报popupitem
                    this.popUpItemTrack();
                });
            })
            this.notifyDialogOpen();
            if(this.is_drack) {
                this.operateDrack();
            }

        },
        // 运营位图片加载完
        imageLoad(){
            let boxHeight = document.getElementById("pop").clientHeight;
            let operateHeight = document.getElementById("pop_contain").clientHeight;
            if (operateHeight>boxHeight) {
                this.show_operate = false;
                this.is_drack = false;
            } else {
                this.show_operate = true;
                this.is_drack = true;
                this.operateDrack();
            }
            this.show_operate_opacity = false;
        },
        // 运营位埋点事件
        operateDrack(){
            const { pre_page:PrePage,cur_page:CurPage,puwid:PUWID,popup_name:popupName,gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark }=this.j_req;
            doTrackPopupItemImp({
                PrePage,
                CurPage,
                PUWID,
                popupName,
                GenderType,
                TopicID,
                TopicName,
                ComicName,
                ComicID,
                TriggerPage,
                ActivityMark,
                Element: this.operate_info.type=="image"?"浮层运营位-图片":"浮层运营位-文字&图片"
            })
        },
        // 关闭-半屏
        closeDialog(){
            slide.down(this.$refs.refpop);
            this.chooseIndex = 0;
            this.chooseIndex1 = 0;
            setTimeout(() => {
                this.h_visible = false; //关闭时为了有slide效果
            },300)
            this.notifyDialogClose();
        },
        // 收银台组件-接收 : 收银台操作
        receiveCashdeskPayMessage(res){
            res.data.good_info = this.j_curgood_info;
            if(res.data.pay_status == 1) {
                this.getViewData();//需要更新swiper
                this.closeDialog();
            }
            this.notifyPayMessage(res);
        },
        // 收银台组件-接收 : 出错
        receiveCashdeskErrorMessage({code=0, message='', data={}} = {}){
            this.notifyErrorMessage(code, message, data);
        },
        // kkb半屏组件-通知 : 拉起
        notifyDialogOpen(){
            debug(`【kkb半屏 - 拉起】`);
            this.$emit('dialogOpen');
        },
        // kkb半屏组件-通知 : 关闭
        notifyDialogClose(){
            debug(`【kkb半屏 - 关闭】`);
            this.$emit('dialogClose');
        },
        // kkb半屏组件-通知 : 跳转充值中心
        notifyRechargeCenterOpen(){
            debug(`【kkb半屏 - 跳转充值中心】`);
            this.$emit('rechargeCenterOpen');
        },
        // kkb半屏组件-通知 : 返回充值中心
        notifyRechargeCenterClose(){
            debug(`【kkb半屏 - 返回充值中心】`);
            this.$emit('rechargeCenterClose');
        },
        // kkb半屏组件-通知 : 支付信息
        notifyPayMessage(res){
            debug(`【kkb半屏 - 支付信息】`, res);
            this.$emit('payMessage', res);
        },
        // kkb半屏组件-通知 : 出错
        notifyErrorMessage(code, message, data={}){
            this.h_loading = false;
            let info = ua.prod ? `${message}` : `[${code}]-${message}`;
            debug(`【kkb半屏 - 出错信息】${info}`);
            toast(`拉起遇到问题~ ${info}`);
            this.$emit("errorMessage", {code, data, message});
        },
        // kkb半屏组件-通知 : 更新visible重制才能重新点击打开
        notifyResetVisibleFalse(){
            // debug(`【kkb半屏 - 重制visible】`);
            this.$emit('update:visible', false);
        },
        // kkb半屏组件-通知 : 商品列表信息 kkb （父组件通过ref可以调用）
        getListData(){
            setTimeout(() => {
                (async () => {
                    let opt = await getBaseParam(this.j_req);
                    let res = await getKkbList(opt);
                    debug(`【收银台 - 商品列表信息】`,res);
                    this.$emit('listData',res);
                })()
            },0);
        },
        setChooseIndex(){
            let ele=this.$refs.mySwiper.swiper;
            this.chooseIndex = ele.activeIndex;
            this.chooseIndex1 = 0;
        },
        // 每次滑向下一个时上报PopupItemImp事件
        slideNextPopupItemImp(){
            let ele=this.$refs.mySwiper.swiper;
            // swiper容器宽度
            let ele_width=ele.width;
            // swiper位移
            let ele_translate=ele.translate;
            // 每次滑动出item数量，3.3为展示出来的块数量
            let slide_count = ele.activeIndex;
            this.chooseIndex = ele.activeIndex;
            this.chooseIndex1 = 0;
            // 记录每次的位移
            // this.slide_x=ele_translate;
            const { pre_page:PrePage,cur_page:CurPage,puwid:PUWID,popup_name:popupName,gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark }=this.j_req;
            for(let i=0;i<this.list[slide_count].length;i++){
                doTrackPopupItemImp({
                    PrePage,
                    CurPage,
                    PUWID,
                    popupName,
                    ElementType:"充值按钮",
                    ElementShowTxt:String(this.list[slide_count][i].recharge_value || ""),
                    GenderType,
                    TopicID,
                    TopicName,
                    ComicName,
                    ComicID,
                    TriggerPage,
                    ActivityMark,
                    ItemPos: i,
                })
            }

            // 更新itemimp事件上报次数，一定要在上报之后再更新
            // this.track_popup_itemimp_count = slide_count;
        },
        // 滑到最后一个，检查是否有未上报的PopupItemImp事件
        endCheckPopupItemImp(){
            // const { pre_page:PrePage,cur_page:CurPage,puwid:PUWID,popup_name:popupName,gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark }=this.j_req;
            // if(this.kkbgoods.length>this.track_popup_itemimp_count){
            //     for(let i=0;i<this.kkbgoods.length-this.track_popup_itemimp_count;i++){
            //         doTrackPopupItemImp({
            //             PrePage,
            //             CurPage,
            //             PUWID,
            //             popupName,
            //             ElementType:"充值按钮",
            //             ElementShowTxt:String(this.kkbgoods[this.track_popup_itemimp_count+i].recharge_value),
            //             GenderType,
            //             TopicID,
            //             TopicName,
            //             ComicName,
            //             ComicID,
            //             TriggerPage,
            //             ActivityMark
            //         })
            //     }
            // }
        },
        // 半屏拉起时漏出3个档位，上报3次，
        popUpItemTrack(){
            let t = this.list[0].length;
            // 记录PopupItemImp事件上报次数
            // this.track_popup_itemimp_count = 0;
            this.chooseIndex = 0;
            const { pre_page:PrePage,cur_page:CurPage,puwid:PUWID,popup_name:popupName,gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark,source_platform:SourcePlatform }=this.j_req;
            let track_param={}
            if(ua.miniprogram){
                track_param={
                    PrePage,// 上一页面
                    CurPage,// 当前页面
                    PUWID,// 弹窗id,为kkb后台配置的唯一活动的id
                    popupName, // 弹窗名称
                    ElementType:"充值按钮",// 元素类型
                    GenderType,// 男女版
                    TopicID,// 专题id 
                    TopicName,// 专题名称 
                    ComicName,// 漫画名称 
                    ComicID,// 漫画id
                    TriggerPage,// 触发页面 
                    ActivityMark,// 活动标识-半屏弹窗中的活动唯一标识 
                    SourcePlatform
                }
            }else{
                track_param={
                    PrePage,// 上一页面
                    CurPage,// 当前页面
                    PUWID,// 弹窗id,为kkb后台配置的唯一活动的id
                    popupName, // 弹窗名称
                    ElementType:"充值按钮",// 元素类型
                    GenderType,// 男女版
                    TopicID,// 专题id 
                    TopicName,// 专题名称 
                    ComicName,// 漫画名称 
                    ComicID,// 漫画id
                    TriggerPage,// 触发页面 
                    ActivityMark,// 活动标识-半屏弹窗中的活动唯一标识 
                }
            }
            for(let i=0;i<t;i++){
                track_param.ElementShowTxt=String(this.list[0][i].recharge_value || ""),// 元素显示文案，右上角标-价格
                track_param.ItemPos = i;
                doTrackPopupItemImp(track_param)
            }
        },
        // 点击上报
        popupItemClk(item, buttonName){
            const { pre_page:PrePage,cur_page:CurPage,puwid:PUWID,popup_name:popupName,gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark,source_platform:SourcePlatform }=this.j_req;
            let track_param={}
            if(ua.miniprogram){
                 track_param={
                    GenderType,
                    TopicID,
                    TopicName,
                    ComicName,
                    ComicID,
                    TriggerPage,
                    ActivityName,
                    ActivityMark,
                    SourcePlatform,
                    PUWID,
                    popupName,
                    CurPage,
                    ElementShowTxt:String(item.recharge_value || ""),
                    ElementType: buttonName,
                    Element: buttonName,
                }
            }else{
                track_param={
                    GenderType,
                    TopicID,
                    TopicName,
                    ComicName,
                    ComicID,
                    TriggerPage,
                    ActivityName,
                    ActivityMark,
                    PrePage,
                    PUWID,
                    popupName,
                    CurPage,
                    ElementShowTxt:String(item.recharge_value || ""),
                    ElementType: buttonName,
                    Element: buttonName,
                }
            }
            doTrackPopupItemClk(track_param)
        },
        // 半屏show时上报
        popUpShow(){
            const { gender_type:GenderType,topic_id:TopicID,topic_name:TopicName,comic_name:ComicName,comic_id:ComicID,trigger_page:TriggerPage,activity_name:ActivityName,activity_mark:ActivityMark,pre_page:PrePage,puwid:PUWID,popup_name:popupName,cur_page:CurPage,source_platform:SourcePlatform,mini_program_version,locate:Locate,cps_parameter }=this.j_req;
            let track_param={}
            if(ua.miniprogram){
                track_param={
                    GenderType,
                    TopicID,
                    TopicName,
                    ComicName,
                    ComicID,
                    TriggerPage,
                    ActivityMark,
                    PrePage,
                    PUWID,
                    popupName,
                    CurPage,
                    SourcePlatform,
                    mini_program_version,
                    Locate,
                    cps_parameter
                }
            }else{
                track_param={
                    GenderType,// 男女版
                    TopicID,// 专题ID 
                    TopicName,// 专题名称 
                    ComicName,// 漫画名称
                    ComicID,// 漫画ID
                    TriggerPage, // 触发页面
                    ActivityName,// 活动名称
                    ActivityMark,// 活动标识-半屏弹窗中的活动唯一标识
                    PrePage,// 上一页面
                    PUWID,// 弹窗id
                    popupName,// 弹窗名称
                    CurPage,// 当前页面，ComicPage - 漫画页，TopicPage - 专题页 
                }
            }
            doTrackPopupShow(track_param);
        },
        // 一维数组转成二维数组
        oneToTwoDimension(arr) {
            let len = arr.length;
            let n = 6; //假设每行显示4个
            let lineNum = len % 6 === 0 ? len / 6 : Math.floor( (len / 6) + 1 );
            let res = [];
            for (let i = 0; i < lineNum; i++) {
                let temp = arr.slice(i*n, i*n+n);
                res.push(JSON.parse(JSON.stringify(temp)));
            }
            this.list = res;
        }
    },
    filters:{
        filtersFenToYuan(v){
            return fenToYuan(v,2);
        }
    }
}
</script>


<style lang="scss">
@function vws($px) {
    @return $px / 100px * 1rem;
}
.fam{font-family: -apple-system, BlinkMacSystemFont, "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif;}
.bd .swiper-pagination-bullet {
    width: vws(14px);
    height: vws(6px);
    border-radius: 0;
    background: #EBEEF5;
    opacity: 1;
    display: block;
}
.bd .swiper-pagination-bullet-active {
    background: #FDE23D;
}
.bd .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0;
    height: vws(6px);
    display: flex;
    justify-content: center;
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/flex.css";
@import "../../../assets/styles/mixins.scss";
*{padding: 0;margin: 0;box-sizing: border-box;}
ul,li,dl,ol {list-style: none; }
em,i {font-style: normal; }
img {width: 100%;vertical-align: middle;border: none;}
a, img {-webkit-touch-callout: none; pointer-events: none;/* 禁止长按链接与图片弹出菜单 */}
.opacity0{opacity:0;}
.re{position:relative}

.pop.show{display:block;}
.pop{
    display:none;z-index:998;position: fixed;left:0;top:0;height:100%;width:100%;overflow: hidden;
    .pop-mask{
        position: absolute;left:0;top:0;height:100%;width:100%;overflow: hidden;background: rgba(0,0,0,.5);
    }
    .pop-mask.transparentbg{
        background: rgba(0,0,0,0);
    }
    .pop-contain{
        transform: translate3d(0,100%,0);
        position: absolute;left:0;bottom:0;width:100%;font-size: vws(24px);color:#000;
        background: #fff;
        border-radius: vws(20px) vws(20px) 0 0;
        .operate-img{
            margin-bottom: vws(-20px);
            border-radius: vws(20px) vws(20px) 0 0;
            width: 100%;
            overflow: hidden;
            img{
                width: 100%;
                display: block;
            }
        }
        .operate-position {
            position: absolute;
            top: vws(-130px);
            left: 0;
            height: vws(152px);
            width: 100%;
            background: linear-gradient(291.74deg, #FF9B02 6.04%, #FF751A 81.47%);
            border-radius: vws(20px) vws(20px) 0 0;
            padding: vws(22px) vws(46px);
            color: #fff;
            font-size: vws(24px);
            .main-title{
                font-size: vws(32px);
                font-weight: 500;
                width: vws(520px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .sub-title{
                width: vws(520px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .img-box{
                width: vws(144px);
                height: vws(144px);
                position: absolute;
                right: vws(23px);
                bottom: vws(42px);
                overflow: hidden;
                img {
                    width: 100%;
                    display: block;
                }
            }
        }
        // 标题
        .hd{
            position:relative; 
            background: #fff;
            border-radius: vws(20px) vws(20px) 0 0;
            // padding:vws(60px) 0;
            // span{font-family: PingFangSC-Medium;font-weight:bold;font-size: vws(34px);color: #000000;}
            // .ico_close{
            //     position: absolute;right: vws(8px);top: 48%;transform: translateY(-50%);
            //     i{display:block;width:vws(66px);height:vws(66px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCBAMAAAAReh3bAAAAG1BMVEUAAAA0NDQ0NDQ0NDQ0NDQ1NTU3Nzc0NDQzMzOq3yguAAAACHRSTlMA7jG2nEMOWMqgP5oAAACFSURBVEjH7ZM9CoAwDEZLQQ/goB0tXkTwZA5Cjy2EkizhDZ065JtKebz+JEmRyEx5TltftwMsbdN1Lp9DrOVVSW17clJVkhXW2L6xIOkoSYQESQdJIhxIOkYSUZDkEAVJmihQAgog4BS8Kb926Mf417lyXH3uoIEu5E7maeCJ4qmMRObJDzogJmMdxHv/AAAAAElFTkSuQmCC") no-repeat 0 0;background-size: 100% 100%;}
            // }
            // 新版设计稿样式
            .fam{
                font-family: PingFang SC, sans-serif, serif;
                font-style: normal;
                font-weight: 500;
                line-height: vws(88px);
                font-size: vws(32px);
                color: #222222;
            }
            .ico_close{
                position: absolute;
                right: vws(36px);
                top: 50%;
                transform: translateY(-50%);
                i{
                   display:block;
                   width:vws(32px);
                   height:vws(32px); 
                   background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgBzZftDYQgDIbL5SZxJffQVdQ5YEZOyHE5CB+llNQnIf6xb99QbUHZGxDkBcJEBowxfs0iq2+/aK3tsix+HcdhuTnP86fvcgWyJbiuC+4A4KKqV3LJtRMtTegN4EyeNYAN5EheNNAjMBoLXELUGOAUpBhuGsAKU0uGMtBKMPK9vAHJtm3+GRqKay4OpVTUZNx7+74DFuW3oYNaV+tN7rEE0i0faVjPGscYSiWgDrAuA2mStOYkE9hazfoNn9+IRFux6DASHceiBxLRI5noofT/XsCVvGSieS8gTbUKNb1oHIdr07quMIOcfvd5gBvxcfwB0YJE7a5J+DwAAAAASUVORK5CYII=") no-repeat 0 0;
                   background-size: 100% 100%;
                }
            }
        }
        // 档位
        .bd-box {
            width: 100%;
            min-width: vws(750px);
        }
        .bd{
            // padding-left:vws(32px);
            width: vws(750px);
            margin: 0 auto;
            .swiper-slide {
                width: vws(750px) !important;
            }
            .goods-box{
                width: vws(750px);
                padding: vws(8px) vws(24px) vws(32px);
                box-sizing: border-box;
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
            }
            .item{
                box-sizing: border-box;
                width:vws(218px);
                // height:vws(140px);
                height:vws(164px);
                // border: vws(2px) solid #F2F2F2; 
                border: vws(2px) solid #EEEEEE;
                border-radius: vws(10px);
                padding-top: vws(28px);
                margin-left: vws(24px);
                margin-top: vws(16px);
                font-size: vws(36px);
                color: #000000;
                font-family: PingFang SC;
                overflow: hidden;
                &.choose-item{
                    // background: #FFFAF6;
                    // border: vws(2px) solid #FFE120;
                    border: vws(2px) solid #FF751A;
                }
                &:nth-child(3n+1) {
                    margin-left: 0;
                }
                .ov{
                    img {
                        width: vws(36px);
                        height: vws(36px);
                        margin-right: vws(8px);
                    }
                    white-space: nowrap;
                    overflow: hidden;
                    width: 100%;
                }
                .i0{
                    position:absolute;
                    right: 0px;
                    top: 0px;
                    max-width: vws(200px);
                    height:vws(28px);
                    overflow:hidden;
                    border-radius: 0 vws(8px) 0 0;
                    img {
                        height: 100%;
                        width: auto;
                        display: block;
                    }
                }
                .i2{
                    width:100%;
                    padding: vws(4px) vws(8px);
                    text-align:center;
                    // font-size:vws(18px);
                    font-size:vws(28px);
                    // color: #FF751A;
                    color: #999999;
                    font-family: PingFang SC;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .i3{
                    position:absolute;
                    left:0;
                    top: 0;
                    font-size:vws(18px);
                    padding: 0 vws(8px);
                    color: #999999;
                    font-family: PingFang SC;
                }
                .i4{
                    display: block;
                    padding: 0 vws(8px);
                    box-sizing: border-box;
                    // color: #FF751A;
                    color: #FF9900;
                    font-size: vws(24px);
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    // background: #FFF3EC;
                    background: #FFF8F2;
                    height: vws(34px);
                    line-height: vws(34px);
                    text-align: center;
                    // width: vws(212px);
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .button-box{
                padding: vws(24px) 0 vws(48px);
                .recharge-button{
                    height: vws(88px);
                    width: vws(640px);
                    background: #FDE23D;
                    border-radius: vws(44px);
                    text-align: center;
                    line-height: vws(88px);
                    font-weight: 500;
                    font-size: vws(32px);
                    color: #442509;
                    margin: 0 auto;
                }
            }
        }
        //底部
        .ft{
            padding:vws(8px) vws(26px) vws(0px) vws(38px);
            .line1{
                .user-info-box {
                    img {
                        width: vws(40px);
                        height: vws(40px);
                        border-radius: vws(20px);
                        margin-right: vws(14px);
                    }
                    .name {
                        color: #222222;
                        font-size: vws(24px);
                        font-weight: 500;
                    }
                }
                span {
                    color: #999999;
                    font-size: vws(24px);
                    font-family: PingFang SC;
                }
            }
            .line2{font-family: PingFangSC-Regular;margin-top:vws(8px);text-align:center;font-size:vws(24px);color: #CBCBCB;transform:scale(.8);transform-origin:center center;}
        }
    }
}

.slideon {
    animation: slideUp .2s 0s linear both;
}
.slideoff {
    animation: slideDown .2s 0s linear both;
}

// 多充多送
.buy_more_more_gifts{
    margin: 0 auto vws(24px);
    width: vws(702px);
    height: vws(310px);
    // background: linear-gradient(178.76deg, #FF8B3F 1.08%, #FFDB95 98.97%);
    background: linear-gradient(178.74deg, #FFE7D3 1.09%, #FFF0E4 98.96%);
    border-radius: vws(16px);
    overflow: hidden;
    .title_warp{
        display: flex;
        box-sizing: border-box;
        align-items: center;
        padding: 0 vws(24px);
        height: vws(68px);
        .title{
            min-width: vws(192px);
            img{
                margin-top: vws(8px);
                display: block;
                overflow: hidden;
                width: vws(192px);
                height: vws(32px);
            }
        }
        .buy_record {
            padding-left: vws(16px);
            // padding-right: vws(8px);
            flex: 1;
            font-family: PingFang SC, sans-serif, serif;;
            font-style: normal;
            font-weight: normal;
            font-size: vws(24px);
            // line-height: vws(28px);
            // color: #FFFFFF;
            color: #FF771B;
            text-align: left;
            
            // text-align: right;
            span{
               // font-size: vws(24px); 
               font-size: vws(28px); 
               // color: #FDE23D;
               color: #FF771B;
               font-weight: 700;
            }
        }
        .details_btn{
            // margin-top: vws(4px);
            // width: vws(24px);
            // height: vws(24px);
            // background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFwSURBVHgBtVaLdcIwDJRZgHQDj5ARvAl0g45AJ4ANzAZtJwgb0A3MBqETqFIjNy6JbUFB790zjs/yyR8JA0pDxIaaRrpnY8wZ/mvk1BG2hIBTOxI8wZZ8mIxjS40nuKiYcJCWjSNpCVb6e8IrRXUCpepeVHbcr3D3wuUo25rzVsi8wBqUxtxElMuRrKjoq0ry4nqBnSN4UbAuCOgEDeQj+dnauclsHsoKsbgNA6+bcBL12YnCeyFsKhwnvnbpR77TASomUTgFr//1x/spK74rJgalkDfx2SxgfP493M++pF0u4MHGC8Tn/wT3s6W0QyTxgdVmXXEGzDvy77hFH4RGc0MUzh0MSfDzz8fZFzivLFQ4XnzZy4FOBla3LpCkCj83aJNk1WYc7AjbzFhMdgFzRSjZqmvT9QrHdK2qCSGGivWC0yWiJtxSydwQ4nmcYLgVacl0MGaBA+FZVTIvF8KhJB5xakHOxJV8GFAa3vi35RtX1h1ynjfxNgAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .d_text {
                padding-right: vws(8px);
                font-weight: 400;
                font-size: vws(26px);
                line-height: vws(30px);
                /* identical to box height, or 117% */
                color: #FF771B;
            }
            .d_icon {
                position: relative;
                width: vws(8px);
                height: vws(16px);
                background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB4SURBVHgBpdHLDYAgDAbgFpcw8cIqTqUjuJWjyNElTG0hJqRaaOJ/IBA+XgXAGZSGlukoo2vG7UxfMFT9CDTstI7RhrwTt6mF8enkSUYZyyJ1DaxXtTDqIyz8giYGIxqbUOMAzvw72vUYV3lcBXd9YQ9JSnk6SHIDcDdldO1vFi4AAAAASUVORK5CYII=");
                background-size: 100% 100%;
            }
        }
    }
    .view_swiper{
        height: vws(308px);
        padding: 0 vws(16px);
        .buy_item{
            margin: 0 vws(8px);
            //margin-right: vws(16px);
            display: inline-block;
            position: relative;
            width: vws(238px);
            height: vws(176px);
            // background: #FFFBF3;
            background: #ffffff;
            border-radius: vws(12px);
            overflow: hidden;
            .see_btn{
                position: absolute;
                bottom: vws(50px);
                left: vws(28px);
                width:vws(36px);height:vws(36px);
                background: url("data:image/png;base64,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") no-repeat 0 0;background-size: 100% 100%;
            }
            p{
                margin: 0 auto;
                padding-top: vws(12px);
                width: vws(192px);
                font-family: PingFang SC, serif;
                font-style: normal;
                font-weight: normal;
                font-size: vws(20px);
                line-height: vws(24px);
                text-align: center;
                // color: #FF771B;
                color: #222222;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
            }
            .label{
                max-width: vws(96px);
                box-sizing: border-box;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0 vws(8px);
                height: vws(34px);
                line-height: vws(34px);
                // border-top-right-radius: vws(4px);
                border-bottom-left-radius: vws(16px);
                // transform: rotate(-180deg);
                //background: #FFECDF;
                // background: linear-gradient(133.81deg, #FFC13B -2.94%, #FF2E58 11.91%, #FF0E67 80.88%, #FF00CE 99.23%);
                overflow: hidden;
                font-size: vws(10px);
                transform: translate(0,0);
                font-family: PingFang SC, serif;
                font-style: normal;
                font-weight: normal;
                color: #FFF;
                img{
                    width: auto;
                    max-width: 100%;
                    height: auto;
                    max-height: 100%;
                }
            }
            .label_r{
                background: #FFECDF;
                color: #FF771B;
            }
            .mask{
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                width: vws(238px);
                height: vws(176px);
                background: rgba($color: #FFFBF3, $alpha: 0.5);
            }
            .receive_btn{
                position: absolute;
                left: 50%;
                bottom: vws(48px);
                transform: translate(-50%, 0);
                z-index: 10;
                width: vws(128px);
                height: vws(48px);
                background: linear-gradient(260.77deg, #FF8B02 6.67%, #FF771B 98.25%);
                box-shadow: 0px vws(8px) vws(8px) #FFCC84;
                border-radius: vws(30px);
                font-family: PingFang SC, serif;
                font-style: normal;
                font-weight: 500;
                font-size: vws(24px);
                line-height: vws(48px);
                text-align: center;
                color: #fff;


            }
        }
        .img-box{
            // position: relative;
            display: flex;
            align-items: center;
            justify-items: center;
            justify-content: center;
            margin: vws(28px) auto 0 auto;
            width: vws(192px);
            height: vws(96px);
            overflow: hidden;
            img{
                // width: auto;
                // max-width: 100%;
                // height: auto;
                // max-height: 100%;
                width: 100%;
                height: 100%;
            }
        }
        .progress_bar{
            margin-top: vws(18px);
            position: relative;
            width: 100%;
            height: vws(12px);
            background: #FFFFFF;
            .done{
                // border-bottom-right-radius: vws(6px);
                // border-top-right-radius: vws(6px);
                // width: 100%;
                height: vws(12px);
                // background: #FF771B;
                background:rgba($color: #FF771B, $alpha: 0.5)
                // display: none;
            }
            .radius{
                border-bottom-right-radius: vws(6px);
                border-top-right-radius: vws(6px);
            }
            .tag{
                box-sizing: border-box;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                padding: 0 vws(16px);
                // width: vws(80px);
                height: vws(36px);
                font-size: vws(24px);
                line-height: vws(36px);
                z-index: 1;
                background: #fff;
                border-radius: vws(20px);
                text-align: center;
                color: #FF771B;
                font-family: PingFang SC, sans-serif, serif;
                font-style: normal;
                font-weight: 500;
            }
            .tag.bg{
                background: #FF771B;
                color: #FFFFFF;
            }
        }
        .progress_bar.first{
            border-bottom-left-radius: vws(6px);
            border-top-left-radius: vws(6px);
            margin-left: 3%;
            width: 97%;
            .done{
                border-bottom-left-radius: vws(6px);
                border-top-left-radius: vws(6px);
            }
        }
        .progress_bar.last{
            border-bottom-right-radius: vws(6px);
            border-top-right-radius: vws(6px);
            margin-right: 4%;
            width: 96%;
            .done{
                border-bottom-right-radius: vws(6px);
                border-top-right-radius: vws(6px);
            }
            .radius{
                width: 100%;
            }
        }
    }
}

@keyframes slideUp {
    100% {
        transform: translate3d(0,0,0);
    }
}

@keyframes slideDown {
    0% {
        transform: translate3d(0,0,0);
    }
    100% {
        transform: translate3d(0,100%,0);
    }
}
</style>







// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/kkbhalfscreen/src/kkbhalfscreen.vue